export default "__VITE_ASSET__0929023d__"